import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { BevelWindow } from '@/components/prototype/bevel-window';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  const { t } = useTranslation('player');

  return (
    <div className="mx-auto flex max-w-[560px] flex-col items-center px-4 py-16 sm:px-5">
      <BevelWindow shadow="lg" title={t('notFound.title')} className="w-full">
        <div className="flex flex-col items-center gap-4 py-6 text-center">
          <p className="text-dim font-mono text-sm">{t('notFound.body')}</p>
          <Button asChild variant="primary">
            <Link to="/">{t('notFound.cta')}</Link>
          </Button>
        </div>
      </BevelWindow>
    </div>
  );
}
